"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Mail, Phone, Calendar, ShieldCheck, Award, Star, Users, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServiceFootprint() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const hours = [{
    day: "Monday",
    time: "7am - 6pm"
  }, {
    day: "Tuesday",
    time: "7am - 6pm"
  }, {
    day: "Wednesday",
    time: "7am - 6pm"
  }, {
    day: "Thursday",
    time: "7am - 6pm"
  }, {
    day: "Friday",
    time: "7am - 6pm"
  }, {
    day: "Saturday",
    time: "8am - 4pm"
  }, {
    day: "Sunday",
    time: "Emergency Only"
  }];
  const todayIndex = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;
  return <section data-section-id="1324" id="our-service-footprint" className="bg-background text-foreground py-20 md:py-28 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="lg:col-span-7 order-1 relative">
            <div className="relative">
              {}
              <div className="absolute -top-5 -left-4 px-4 py-2 z-20 rounded-md" style={{
              backgroundColor: "var(--accent)",
              border: "1px solid var(--foreground)",
              transform: "rotate(-2deg)",
              boxShadow: "4px 4px 0 var(--foreground)"
            }} aria-hidden="true">
                <div className="w-full h-full flex items-center justify-center font-mono text-xs font-bold tracking-widest text-foreground uppercase">
                  Why Clients Trust Us
                </div>
              </div>

              {}
              <div className="relative rounded-md overflow-hidden bg-card p-8 md:p-12 flex flex-col justify-between" style={{
              border: "1px solid var(--border)",
              boxShadow: "12px 12px 0 var(--foreground)",
              minHeight: "520px"
            }}>
                {}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 my-auto z-10 relative">
                  <div className="p-5 rounded-md bg-background/80 border border-border shadow-sm flex items-center gap-4">
                    <div className="p-3 rounded-md bg-accent/10 text-accent">
                      <Users className="size-7" />
                    </div>
                    <div>
                      <div className="font-default font-extrabold text-2xl md:text-3xl text-foreground">500+</div>
                      <div className="font-mono text-xs uppercase tracking-wider text-secondary">Satisfied Clients</div>
                    </div>
                  </div>

                  <div className="p-5 rounded-md bg-background/80 border border-border shadow-sm flex items-center gap-4">
                    <div className="p-3 rounded-md bg-accent/10 text-accent">
                      <Star className="size-7 fill-accent" />
                    </div>
                    <div>
                      <div className="font-default font-extrabold text-2xl md:text-3xl text-foreground">5.0 </div>
                      <div className="font-mono text-xs uppercase tracking-wider text-secondary">200+ Reviews</div>
                    </div>
                  </div>

                  <div className="p-5 rounded-md bg-background/80 border border-border shadow-sm flex items-center gap-4">
                    <div className="p-3 rounded-md bg-accent/10 text-accent">
                      <Clock className="size-7" />
                    </div>
                    <div>
                      <div className="font-default font-extrabold text-2xl md:text-3xl text-foreground">25+</div>
                      <div className="font-mono text-xs uppercase tracking-wider text-secondary">Years Experience</div>
                    </div>
                  </div>

                  <div className="p-5 rounded-md bg-background/80 border border-border shadow-sm flex items-center gap-4">
                    <div className="p-3 rounded-md bg-accent/10 text-accent">
                      <Award className="size-7" />
                    </div>
                    <div>
                      <div className="font-default font-extrabold text-2xl md:text-3xl text-foreground">ISA</div>
                      <div className="font-mono text-xs uppercase tracking-wider text-secondary">Certified Arborist</div>
                    </div>
                  </div>
                </div>

                {}
                <div className="mt-8 pt-6 border-t border-border flex flex-wrap items-center justify-center gap-4 z-10 relative">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-accent/20 text-foreground font-mono text-xs font-bold tracking-wider uppercase border border-accent">
                    <ShieldCheck className="size-4 text-accent" /> Insured
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-accent/20 text-foreground font-mono text-xs font-bold tracking-wider uppercase border border-accent">
                    <ShieldCheck className="size-4 text-accent" /> Licensed
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-accent/20 text-foreground font-mono text-xs font-bold tracking-wider uppercase border border-accent">
                    <ShieldCheck className="size-4 text-accent" /> Certified
                  </span>
                </div>

                {}
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-full z-10 pointer-events-none opacity-40" style={{
                animation: "wvc-bounce 1200ms ease-in-out infinite"
              }}>
                  <svg width="56" height="72" viewBox="0 0 56 72" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M28 2C14.7 2 4 12.5 4 25.5C4 41 28 70 28 70C28 70 52 41 52 25.5C52 12.5 41.3 2 28 2Z" fill="var(--accent)" stroke="var(--foreground)" strokeWidth="2" />
                    <circle cx="28" cy="24" r="10" fill="var(--background)" stroke="var(--foreground)" strokeWidth="1.5" />
                    <rect x="27" y="18" width="2" height="12" fill="var(--foreground)" />
                    <rect x="22" y="23" width="12" height="2" fill="var(--foreground)" />
                  </svg>
                </div>
              </div>

              {}
              <div className="absolute -bottom-6 -right-4 z-20 px-4 py-2 rounded-md" style={{
              backgroundColor: "var(--foreground)",
              border: "1px solid var(--accent)",
              boxShadow: "4px 4px 0 var(--accent)",
              transform: "rotate(2deg)"
            }}>
                <span className="font-mono text-background text-sm font-bold tracking-wider uppercase">DFW SERVICE HUB</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 order-2 flex flex-col">
            {}
            <div className="font-mono text-xs md:text-sm uppercase tracking-[0.2em] text-secondary font-medium mb-6">
              07 // DEPLOYMENT // 32.7555°N 97.3308°W
            </div>

            {}
            <h2 className="font-default text-foreground text-5xl md:text-6xl lg:text-7xl font-extrabold leading-[0.95] tracking-tighter mb-8">
              OUR SERVICE{" "}
              <span className="relative inline-block">
                FOOTPRINT
                <svg className="absolute -bottom-2 left-0 w-full" height="18" viewBox="0 0 220 18" fill="none" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M0 10 L220 10" stroke="var(--accent)" strokeWidth="6" strokeLinecap="square" fill="none" />
                </svg>
              </span>
            </h2>

            {}
            <div className="mb-6">
              <p className="font-default font-medium text-foreground text-lg md:text-xl leading-snug">
                Serving Fort Worth &
                <br />
                The Greater DFW Metroplex
              </p>
            </div>

            {}
            <div className="mb-6">
              <svg width="100%" height="16" viewBox="0 0 320 16" fill="none" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0 8 H310" stroke="var(--border)" strokeWidth="1" fill="none" />
                <rect x="310" y="3" width="10" height="10" fill="var(--accent)" />
              </svg>
            </div>

            {}
            <div className="mb-8">
              <div className="font-mono text-xs uppercase tracking-[0.2em] text-secondary font-medium mb-3">
                § OPERATIONAL HOURS
              </div>
              <ul className="divide-y-1 border-t border-b" style={{
              borderColor: "var(--border)"
            }}>
                {hours.map((h, i) => {
                const isToday = i === todayIndex;
                return <li data-index={i} key={h.day} className={`flex items-center justify-between py-3 px-3 -mx-3 transition-colors ${isToday ? "bg-accent/10" : ""}`}>
                      <span className="font-default text-foreground text-lg md:text-xl font-semibold leading-none">
                        {h.day}
                        {isToday && <span className="ml-2 font-mono text-[10px] font-bold uppercase tracking-widest text-accent align-middle">
                            [ACTIVE]
                          </span>}
                      </span>
                      <span className="font-mono text-secondary text-sm md:text-base font-medium text-right">
                        {h.time}
                      </span>
                    </li>;
              })}
              </ul>
            </div>

            {}
            <div className="mb-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-md" style={{
              backgroundColor: "var(--accent)",
              border: "1px solid var(--foreground)",
              boxShadow: "4px 4px 0 var(--foreground)",
              transform: "rotate(-1deg)",
              color: "var(--foreground)"
            }}>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
                  <rect x="4" y="4" width="14" height="14" stroke="var(--foreground)" strokeWidth="2" />
                  <path d="M8 11 L10 13 L14 9" stroke="var(--foreground)" strokeWidth="2" strokeLinecap="square" />
                </svg>
                <span className="font-mono font-bold text-sm leading-none uppercase tracking-wider">CREWS ON SITE</span>
              </div>
            </div>

            {}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-8">
              <Link to="tel:8175033131" className="group inline-flex items-center gap-3 px-5 py-3 rounded-md transition-all" style={{
              backgroundColor: "var(--foreground)",
              color: "var(--background)",
              border: "1px solid var(--accent)",
              boxShadow: "6px 6px 0 var(--accent)"
            }}>
                <Phone className="size-6 text-accent" strokeWidth={2.5} />
                <span className="font-mono font-extrabold text-lg md:text-xl tracking-tight">
                  (817) 503-3131
                </span>
              </Link>

              <Link to="/GetQuotePage" className="group inline-flex items-center gap-2 px-5 py-3 rounded-md transition-all hover:bg-accent/10" style={{
              border: "1px solid var(--foreground)",
              boxShadow: "4px 4px 0 var(--foreground)"
            }}>
                <SafeHydrate><Calendar className="size-5 text-accent" strokeWidth={2} /></SafeHydrate>
                <span className="font-mono font-bold text-base uppercase tracking-wide">
                  Schedule Now
                </span>
              </Link>
            </div>

            {}
            <div className="flex flex-col gap-4">
              <Link to="mailto:ops@arborprotexas.com" className="group inline-flex items-center gap-2 text-foreground">
                <Mail className="size-5 text-accent" strokeWidth={2} />
                <span className="relative font-mono font-bold text-base md:text-lg break-all">
                  ops@arborprotexas.com
                  <div className="absolute -bottom-1 left-0 w-0 h-0.5 bg-accent group-hover:w-full transition-all duration-300" />
                </span>
              </Link>
            </div>

            {}
            <div className="mt-10">
              <Button asChild className="rounded-md bg-accent text-accent-foreground font-mono font-bold text-lg px-10 py-6 h-auto hover:bg-foreground hover:text-accent transition-all" style={{
              border: "1px solid var(--foreground)",
              boxShadow: "6px 6px 0 var(--foreground)"
            }}>
                <Link to="/GetQuotePage">REQUEST DISPATCH</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes wvc-bounce {
          0%, 100% { transform: translate(-50%, -100%) translateY(0); }
          50% { transform: translate(-50%, -100%) translateY(-8px); }
        }
        @media (prefers-reduced-motion: reduce) {
          [style*="wvc-bounce"] { animation: none !important; }
        }
      `}</style>
    </section>;
}